export default __webpack_public_path__ + "static/media/brigoshaLogo.9983fe8d.svg";